(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jf-pros-siblings"] && !Shopify.designMode) return;
  try {
    
  /* Live's Swiper arrows on the scroll-snap track: each click moves one card (its width and the 25px gap); the previous arrow
     is disabled at the start and the next one at the end, as Swiper's are. */
  class JfProsSiblings extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.jf-pros-siblings__track');
      this.prev = this.querySelector('.jf-pros-siblings__arrow--prev');
      this.next = this.querySelector('.jf-pros-siblings__arrow--next');
      if (!this.track || !this.prev || !this.next) return;
      /* One controller per connection, so a re-inserted carousel never doubles its listeners. */
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      const update = () => this.update();
      this.prev.addEventListener('click', () => this.step(-1), { signal });
      this.next.addEventListener('click', () => this.step(1), { signal });
      this.track.addEventListener('scroll', update, { passive: true, signal });
      window.addEventListener('resize', update, { signal });
      this.update();
    }

    disconnectedCallback() {
      if (this.listeners) this.listeners.abort();
    }

    step(direction) {
      const card = this.track.querySelector('.jf-pros-siblings__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    update() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= end - 1;
    }
  }

  if (!customElements.get('jf-pros-siblings')) customElements.define('jf-pros-siblings', JfProsSiblings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
